import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { getZitadelConfig } from './zitadelMode';
import { createDebugLogger } from '../utils/debug';

const dlog = createDebugLogger('zitadel');

let _instance = null;

/**
 * Singleton UserManager — oidc-client-ts.
 *
 * Per Spec orbit-specs/zitadel-auth-integration.md §3:
 *  - Tokens in sessionStorage (XSS-Resistenz, Tab-Close = Logout OK)
 *  - PKCE S256 (Public Client, kein Secret)
 *  - id_token persistiert für end_session_endpoint-Hint
 *
 * Refresh-Strategy: Automatic via silent renew (loadUserInfo=false damit
 * Refresh nicht stets das User-Info-Endpoint anpingt). User-Manager kümmert
 * sich um Token-Rotation, hier nur das State-Mapping zu Orbit's AuthProvider.
 */
export function getZitadelClient() {
  if (_instance) return _instance;
  const cfg = getZitadelConfig();
  _instance = new UserManager({
    authority: cfg.issuer,
    client_id: cfg.clientId,
    redirect_uri: cfg.redirectUri,
    post_logout_redirect_uri: cfg.postLogoutRedirectUri,
    scope: cfg.scope,
    response_type: 'code',
    // PKCE is enabled by default for code-flow in oidc-client-ts v3+
    automaticSilentRenew: false, // wir machen Refresh on-demand bei 401
    loadUserInfo: false,
    monitorSession: false,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
    // Audience explizit als resource-Parameter (RFC 8707) zusätzlich zum
    // Scope. Zitadel akzeptiert beides; Belt-and-Suspenders gegen unklare
    // Aud-Claim-Semantik in der Spec. Siehe security-review HIGH-1.
    extraQueryParams: { resource: cfg.audience },
    extraTokenParams: { resource: cfg.audience },
  });
  _instance.events.addUserLoaded((user) => dlog('user loaded', { sub: user.profile?.sub }));
  _instance.events.addUserUnloaded(() => dlog('user unloaded'));
  _instance.events.addSilentRenewError((err) => dlog('silent renew error', err));
  return _instance;
}

/**
 * Reset (test-only — Singleton verhindert normalerweise Reinit).
 */
export function _resetZitadelClient() {
  _instance = null;
}
